export default {"src":"/_next/static/media/chevron.b61f507d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};